import { render, staticRenderFns } from "./Comprar.vue?vue&type=template&id=1db3d067&"
import script from "./Comprar.vue?vue&type=script&lang=js&"
export * from "./Comprar.vue?vue&type=script&lang=js&"
import style0 from "./Comprar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Comprar.vue"
export default component.exports